import type { Expression } from '../model/poses'

export const neutral = { x: 0, y: 0, z: 0, pitch: 0, yaw: 0, roll: 0, stretch: 0 }
export type MotionPose = typeof neutral
export type Frame = MotionPose & { at: number }

export const frame = (at: number, pose: Partial<MotionPose> = {}): Frame => ({
  ...neutral,
  ...pose,
  at,
})

export const noEffects = { star: 0, ripple: 0, rippleOpacity: 0, trail: 0, trailPosition: 0 }
export type MoveEffects = typeof noEffects
export const effectChannels = Object.keys(noEffects) as (keyof MoveEffects)[]
export type EffectFrame = MoveEffects & { at: number }

export const effect = (at: number, values: Partial<MoveEffects> = {}): EffectFrame => ({
  ...noEffects,
  ...values,
  at,
})

export interface Move {
  label: string
  description: string
  duration: number
  expression: Expression
  frames: Frame[]
  effects?: EffectFrame[]
  expressions?: readonly (readonly [number, Expression])[]
}

export const poseChannels = Object.keys(neutral) as (keyof MotionPose)[]
